"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const StackElements_1 = require("../../../components/StackElements");
const Star_1 = require("@mui/icons-material/Star");
const CheckCircle_1 = require("@mui/icons-material/CheckCircle");
const merge_1 = require("merge");
const InvoiceItemTypes_1 = require("../../../types/InvoiceItemTypes");
const TipLabelIcon_style_1 = require("./TipLabelIcon.style");
function TipLabelIcon({ iconIndex, fontSize = '16px', noTipLabelIconOverrides, includeTipLabelIconOverrides, option, selected, tipLabelType, blackThemeStyle, isIncludeZero, }) {
    const iconsCount = isIncludeZero ? [1, 1, 2, 3, 4] : [1, 2, 3, 4];
    const LabelIcon = tipLabelType === InvoiceItemTypes_1.TipLabelTypeEnum.Stars ? Star_1.default : CheckCircle_1.default;
    const styles = (0, TipLabelIcon_style_1.default)({ fontSize, tipLabelType, selected, blackThemeStyle });
    return ((0, jsx_runtime_1.jsx)(StackElements_1.StackElements, { direction: "row", alignItems: "center", justifyContent: "center", spacing: 0, children: Array(iconsCount[iconIndex])
            .fill(0)
            .map(() => {
            if (option === 0) {
                return ((0, jsx_runtime_1.jsx)(LabelIcon, { color: "disabled", sx: (0, merge_1.merge)(styles.noTipLabelIcon, noTipLabelIconOverrides) }));
            }
            return (0, jsx_runtime_1.jsx)(LabelIcon, { sx: (0, merge_1.merge)(styles.includeTipLabelIcon, includeTipLabelIconOverrides) });
        }) }));
}
exports.default = TipLabelIcon;
